var findByValue = function (searchedValue) {
    return function (item) {
        return item.value === searchedValue;
    };
};
export { findByValue };
